/* __next_internal_client_entry_do_not_use__  cjs */ "use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = SliderValueLabel;
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _sliderClasses = _interopRequireDefault(require("./sliderClasses"));
var _jsxRuntime = require("react/jsx-runtime");
const useValueLabelClasses = (props)=>{
    const { open } = props;
    const utilityClasses = {
        offset: (0, _clsx.default)(open && _sliderClasses.default.valueLabelOpen),
        circle: _sliderClasses.default.valueLabelCircle,
        label: _sliderClasses.default.valueLabelLabel
    };
    return utilityClasses;
};
/**
 * @ignore - internal component.
 */ function SliderValueLabel(props) {
    const { children, className, value } = props;
    const classes = useValueLabelClasses(props);
    if (!children) {
        return null;
    }
    return /*#__PURE__*/ React.cloneElement(children, {
        className: (0, _clsx.default)(children.props.className)
    }, /*#__PURE__*/ (0, _jsxRuntime.jsxs)(React.Fragment, {
        children: [
            children.props.children,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: (0, _clsx.default)(classes.offset, className),
                "aria-hidden": true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: classes.circle,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: classes.label,
                        children: value
                    })
                })
            })
        ]
    }));
}
"production" !== "production" ? SliderValueLabel.propTypes = {
    children: _propTypes.default.element.isRequired,
    className: _propTypes.default.string,
    value: _propTypes.default.node
} : void 0;
